import {
  CalendarEntry,
  getCircularLetterPdf,
  LanguageLocaleEnum,
} from "@/api/openapi";
import { translate } from "@/config/translator";
import { downloadBlob } from "@/config/utils";
import { isSameDay } from "date-fns";
import { ReactNode } from "react";
// @ts-expect-error i dont know why this is displays an error, but trust me, it works
import { Value } from "react-calendar/src/shared/types";
import { toast } from "react-toastify";
import { clsx } from "clsx/lite";

function onChangeSelectedCalendarEntries(
  date: Value,
  setSelectedDate: (date: Date | null) => void,
  setSelectedCalendarEntries: (calendarEntries: CalendarEntry[] | null) => void,
  calendarEntries: CalendarEntry[],
) {
  const dateString = new Date(date?.toString() ?? "").toISOString();

  setSelectedDate(new Date(dateString));
  setSelectedCalendarEntries(
    calendarEntries?.filter((calendarEntry) =>
      isSameDay(calendarEntry.date, dateString),
    ) ?? null,
  );
}

export function tileContentFunc(
  date: Date,
  selectedDate: Date | null,
  setSelectedDate: (date: Date | null) => void,
  setSelectedCalendarEntries: (calendarEntries: CalendarEntry[] | null) => void,
  calendarEntries: CalendarEntry[],
): ReactNode {
  const hasEvents = Boolean(
    calendarEntries?.find((deadline) =>
      isSameDay(new Date(deadline.date), date),
    ),
  );

  const className = clsx(
    "aspect-square",
    "rounded-md",
    "w-9",
    "h-9",
    "relative",
    "flex",
    "justify-center",
    "items-center",
    "duration-200",
    "ease-in-out",
    "overflow-visible",
  );

  if (hasEvents) {
    return (
      <button
        onClick={() =>
          onChangeSelectedCalendarEntries(
            date,
            setSelectedDate,
            setSelectedCalendarEntries,
            calendarEntries,
          )
        }
        className={clsx(
          className,
          "text-font-black",
          "cursor-pointer",
          "group",
          selectedDate &&
            isSameDay(selectedDate, date) &&
            "bg-primary text-font-white font-medium",
        )}
      >
        {date?.getDate()}
        <div
          className={clsx(
            "w-3",
            "h-[2.5px]",
            "duration-200",
            "ease-in-out",
            "rounded-full",
            selectedDate && isSameDay(selectedDate, date)
              ? "bg-white w-5"
              : "bg-primary group-hover:w-5",
            "absolute",
            "top-8",
            "left-1/2",
            "-translate-x-1/2",
          )}
        />
      </button>
    );
  }
  return <div className={className}>{date.getDate()}</div>;
}

export function onDownloadCircularLetter(
  circularLetterId: string,
  lang: LanguageLocaleEnum,
) {
  getCircularLetterPdf({
    path: { circular_letter_id: circularLetterId },
    responseType: "blob",
  }).then((response) => {
    if (response.error) {
      toast(translate("somethingWentWrong", lang));
    } else {
      downloadBlob(response);
    }
  });
}
